export default "__VITE_ASSET__cd0c9646__"